<template>
  <div class="mars-box">
    <dl>
      <dt class="show-flex-box-c">
        <span>硬件支持</span>
        <strong></strong>
      </dt>
      <dd class="choose-answer show-flex-box-c">
        <strong>为打造可帮、可带、可复制“德阳经开创新教育模式”，创新教育课程实施不太依赖高大上的硬件，主张“一张纸，一支笔”利用身边材料也能上好创新课理念。</strong>
      </dd>
      <dd class="mars-box-video">
        <div class="mars-video">
          <public-player v-if="currentPlayObj" :videoPlayMessage='currentPlayObj'></public-player>
        </div>
        <div class="mars-slide-box show-flex-box-r">
          <div class="slide-left show-flex-box-r"><strong class="swiper-mars-prevs"></strong></div>
          <div class="mars-slide mars-swiper">
            <ul class="swiper-wrapper swiper-no-swiping">
              <li class="swiper-slide" v-for= "(item,index) in marsBoxList" :key= "index">
                <span><img :src= "item.o" alt="德阳经开科创" draggable="false"></span>
              </li>
            </ul>
          </div>
          <div class="slide-right show-flex-box-r"><strong class="swiper-mars-nexts"></strong></div>
          <div class="swiper-pagination swiper-mars-pagination"></div>
        </div>
      </dd>
    </dl>
  </div>
</template>
<script>
import "@/../static/css/swiper-4.4.1.min.css"
import Swiper from '@/../static/js/swiper-4.4.1.min.js'
// import publicPlayer from '@/components/common/public_player'
import publicPlayer from '@/components/common/video_player_cpn'


export default {
  name: 'mars_box_cpn',
  data () {
    return {
      state: '',
      currentPlayObj: false,
      marsBoxList: []
    }
  },
  components: {
    publicPlayer
  },
  created() {
    this.getHomeMarsbox();
  },
  updated() {
    this.initMarsBoxSwiper();
  },
  methods: {
    initMarsBoxSwiper: function() {
      var marsSwiper = new Swiper('.mars-swiper', {
        speed: 1000,
        autoplay: {
          delay: 3000
        },
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween : 15,
        noSwiping: true,
        watchOverflow: true,
        pagination: {
          el: '.swiper-mars-pagination',
        },
        navigation: {
          prevEl: '.swiper-mars-prevs',
          nextEl: '.swiper-mars-nexts',
        },
      });
    },
    playVideo: function() {
      var videoUrl = {
        id: 1,
        type: 'video',
        url:this.videoUrl
      }
      this.$emit('clickPlay',videoUrl);
    },
    closeVideo: function() {

    },
    getHomeMarsbox: function() {
      this.$client.getHomeMarsbox()
      .then((res) => {
        if (res.code == '200' || res.code == 200) {
          this.marsBoxList = res.data.images;
          this.currentPlayObj = res.data.video; 
        }
      })
    }
  },
  watch: {
    videoUrl: function() {
      this.$refs.videoPlayer.player.src(this.videoUrl)
    },
    state: function() {
      this.$refs.videoPlayer.player.pause()
    }
  }
}
</script>
<style lang="less" scoped>

  .mars-box-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .mars-box {
    width: 100%;
    padding-bottom: 91px;
    background: #fafafa;
    &>dl {
      &>dt {
        align-items: center;
        padding-bottom: 40px;
        &>span{
          word-wrap: none;
          .mars-box-font-style( 40px; bold; auto; #191D21 );
          padding-top: 79px;
        }
        &>strong{
          display: block;
          width: 130px;
          height: 5px;
          background: #FF7800;
          margin-top: 19px;
          // margin-bottom: 38px;
        }
      }
      &>.choose-answer{
        align-items: center;
        padding-bottom: 19px;
        &>strong{
          word-wrap: none;
          .mars-box-font-style( 18px; 400; 34px; #3E3A39 );
        }
      }
      &>.mars-box-video {

        .mars-video {
          width: 1200px;
          height: 540px;
          margin: 42px auto 30px;
        }
        .mars-slide-box {
          width: 1296px;
          height: 200px;
          margin: 0 auto;
          .slide-left, .slide-right{
            width: 48px;
            height: 100%;
            cursor: pointer;
          }
          .slide-left strong, .slide-right strong {
            flex-grow: 1;
            flex-shrink: 0;
            background-repeat: no-repeat;
            background-repeat: no-repeat;
            background-size: 18px 30px;
          }
          .slide-left strong{
            background-position: center left;
            background-image: url("../../assets/common/marsbox_hover_left.png");
          }
          .slide-right strong{
            background-position: center right;
            background-image: url("../../assets/common/marsbox_hover_right.png");
          }
          .mars-slide {
            overflow-x: hidden;
            width: 1200px;
            &>ul {
              height: 200px;
              &>li {
                display: flex;
                width: 390px;
                justify-content: center;
                align-items: flex-end;
                span {
                  display: flex;
                  overflow: hidden;
                  width: 390px;
                  height: 200px;
                  img {
                    display: block;
                    width: 100%;
                    flex-grow: 1;
                    object-fit: cover;
                  }
                }
              }
            }
          }
        }
        .sorter-nav {
          margin-top: 30px;
          span {
            display: block;
            width: 50px;
            height: 2px;
            border-radius: 0;
            margin-right: 10px;
            background: #fff;
          }
          span:last-child {
            margin-right: 0;
          }
          span.slide-index {
            background: #ff7800;
          }
        }
      }
    }
  }
</style>
<style>
.mars-slide-box {
  position: relative;
  padding-bottom: 32px;
}
.mars-slide-box .swiper-pagination {
  display: flex;
  justify-content: center;
  position: absolute;
  width: 100%;
  bottom: 0;
}
.mars-slide-box .swiper-pagination span {
  display: block;
  width: 50px;
  height: 2px;
  border-radius: 0;
  margin-right: 10px;
  background: #fff;
}
.mars-slide-box .swiper-pagination span:last-child {
  margin-right: 0;
}
.mars-slide-box .swiper-pagination span.swiper-pagination-bullet-active {
  background: #ff7800;
}
</style>




// WEBPACK FOOTER //
// src/components/home/mars_box_cpn.vue